import { render } from "./MyHeader.vue?vue&type=template&id=0684df9a&scoped=true&ts=true"
import script from "./MyHeader.vue?vue&type=script&lang=ts"
export * from "./MyHeader.vue?vue&type=script&lang=ts"

import "./MyHeader.vue?vue&type=style&index=0&id=0684df9a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0684df9a"]])

export default __exports__